import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { Button } from "../../atoms";
import { MagazineCoverImageCard } from "../../../arrow/components/Atoms/MagazineCoverImage";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { STATIC_KEYWORDS } from "../../../constants";
import { getMagazinesTimeStamp } from "../../../arrow/utils/timestamp-utils";
import { getTemplateName, getCategoryAndSubCategory } from "../../../ga-utils";

import "./magazine-card.m.css";

export const LatestEditionMagazineBlock = ({ story, qtConfig }) => {
  const collectionSlug = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "latest_magazine_slug"], "")
  );
  const latestMagazineDetails = useSelector((state) => get(state, ["qt", "data", "latestMagazineDetails"], {}));

  if (!collectionSlug) {
    return null;
  }
  const latestIssue = latestMagazineDetails?.data || {};
  const bannerLabel = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "magazine_banner_story_page"], "")
  );
  const { name, summary, "issue-date": issueDate, slug } = latestIssue;
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const { READ_NOW } = STATIC_KEYWORDS;

  const config = { magazineSlug: `/magazine/${slug}`, customUrlPath: `magazine/${slug}` };
  const readMagazineLink = Object.keys(latestIssue).length > 0 && `/magazine/${slug}`;
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const trackReadMagClick = () => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(
        window.location,
        pageType,
        qtConfig,
        story
      );
      window.dataLayer.push({
        event: "dl_cta_click",
        link_url: readMagazineLink,
        link_text: READ_NOW?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  return (
    <div styleName="card-container">
      <div styleName="image-container">
        {Object.keys(latestIssue).length ? <MagazineCoverImageCard collection={latestIssue} config={config} /> : null}
      </div>
      <div styleName="content-container">
        <div styleName="banner-container">
          <div styleName="banner">{bannerLabel}</div>
        </div>
        <span styleName="headline">{name}</span>
        <p styleName="date">{getMagazinesTimeStamp(issueDate)}</p>
        <p styleName="description">{summary}</p>
        {isDesktop ? (
          <a href={readMagazineLink} onClick={trackReadMagClick}>
            <Button customStyleName={"bg-brand-primary"}>{READ_NOW}</Button>
          </a>
        ) : (
          <Link
            className="load-more-with-arrow"
            href={readMagazineLink}
            disableAjaxLinks={true}
            onMouseDown={trackReadMagClick}
          >
            <div styleName="read-more">
              {READ_NOW}
              {/* <SvgIconHandler type="right-arrow-two" width="18" height="18" /> */}
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};
